import styled from 'styled-components';
import {
  flexbox,
  alignItems,
  flexDirection,
  justifyContent
} from '../../styles/helpers/flexbox';

const Wrapper = styled.span((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${flexDirection('column')};

    border-right: 2px solid ${colours.grey[500]};
    box-sizing: border-box;
    font-size: 12px;
    position: relative;
    height: fit-content;
    margin-top: -1px;

    &:last-child {
      border-right: none;
    }
`;
});

const FixedWrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
  position: sticky;
  top: 0;
  z-index: 6;
  border-top: 1px solid ${colours.grey[400]};
`;
});

const StandardWrapper = styled.div((props) => {
  const VERTICAL_WIDTH = 54;
  const { activities } = props;
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${justifyContent('space-between')};

    width: ${activities * VERTICAL_WIDTH}px;
    min-height: 40px;
    height: 40px;
    background-color: #c3d5e1
    border: ${activities > 0 ? `1px solid ${colours.grey[400]}` : 'none'};
    border-right: ${activities > 0 ? `1px solid ${colours.grey[500]}` : 'none'};
    border-top: none;
    box-sizing: border-box;
    font-size: 12px;
    overflow: hidden;
    cursor: pointer;

    .leftAlign {
      margin-left: 5px;
    }

    @media screen and (max-width: 1100px) {
      min-height: 30px;
      height: 30px;
    }
`;
});

const ActivityHeaderWrapper = styled.span((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};

    height: 150px;
    font-size: 12px;
    background-color: #eaf9f9;
    color: ${colours.grey[800]};
`;
});

const CollapsedWrapper = styled.span((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${flexDirection('column')};

    width: 54px;
    border-right: 1px solid ${colours.grey[500]};
`;
});

const Content = styled.span((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${flexDirection('column')};

    width: calc(100% - 17px);
    color: ${colours.grey[800]};
`;
});

const TopicName = styled.div((props) => {
  const { palette } = props.theme;

  return `
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: ${palette.primary.dark};
`;
});

const ExternalKey = styled(TopicName)`
  text-transform: uppercase;
`;

const Icon = styled.div`
  ${flexbox()};
  ${alignItems('center')};

  cursor: pointer;
  height: 40px;

  [class^='svgIconComponent'] {
    width: 15px !important;
  }

  &:hover {
    path {
      fill: #3b4e5e !important;
    }
  }

  &:active {
    path {
      fill: #000 !important;
    }
  }
`;

const Info = styled.div`
  ${flexbox()};
  ${justifyContent('space-between')};
  ${alignItems('center')};

  width: calc(100% - 22px);
`;

export {
  Wrapper,
  ExternalKey,
  TopicName,
  Icon,
  Content,
  StandardWrapper,
  ActivityHeaderWrapper,
  Info,
  FixedWrapper,
  CollapsedWrapper
};



// WEBPACK FOOTER //
// ./components/topic/styled.js